import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import Recaptcha from 'react-recaptcha';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import IconArrowBack from '@material-ui/icons/ArrowBack';
import IconVpnKey from '@material-ui/icons/VpnKey';

import commonStyles from '../common/Styles';

import IconButtonLink from '../common/IconButtonLink';
import IcoTextField from '../common/IcoTextField';
// eslint-disable-next-line
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const styles = (theme) => {
  const common = commonStyles(theme);
  return {
    header: common.header,
    form: common.form,
    actionButtons: common.actionButtons,
    text: common.text,
    notes: {
      margin: '4px 24px 24px',
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 14,
      color: 'rgba(0, 0, 0, 0.87)',
      lineHeight: 1.5,
      '&[data-error]': {
        color: theme.palette.error[500],
      },
    },
    recaptcha: {
      margin: '32px 0 0 32px',
    },
  };
};

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordRepeat: '',
      passwordInvalid: true,
      passwordTouched: false,
      passwordRepeatInvalid: true,
      passwordRepeatTouched: false,
      inProgress: false,
      recaptchaVerified: false,
    };
    this.handleBlur = (event) => {
      event.persist();
      const { target: { name }} = event;
      this.setState({  [`${name}Touched`]: true }, () => this.updateState(event));
    };
    this.updateState = ({ target: { name, value } }) => {
      this.setState({ [name]: value }, () => this.validate(name));
    };
    this.resetPassword = (event) => {
      const { username, token, password } = this.state;
      if (!this.validate() || this.state.inProgress) {
        return;
      }
      this.setState({ inProgress: true, resetError: false });
      event.preventDefault();
      window.AvaCAS.recoverPassword({ username, token, password })
        .then(
          (data) => {
            this.setState({ afterReset: true });
          },
          (error) => {
            this.setState({ inProgress: false, resetError: true });
          }
        );
    };
    this.validate = (field = false) => {
      let { usernameInvalid, passwordRepeatInvalid, passwordInvalid, passwordRepeatTouched, passwordTouched, usernameTouched } = this.state;
      if (field === 'username' || !field) {
        usernameInvalid = !emailRegexp.test(this.state.username) && usernameTouched && this.state.username;
        const usernameError = usernameInvalid ? 'Username must be a valid e-mail address' : '';
        this.setState({ usernameInvalid, usernameError });
      }
      if (field === 'password' || !field) {
        passwordInvalid = (this.state.password || '').length < 8 && passwordTouched && !!this.state.password;
        const passwordError = passwordInvalid ? 'Password must have at least 8 characters' : '';
        this.setState({ passwordInvalid, passwordError });
      }
      if (field === 'passwordRepeat' || !field) {
        passwordRepeatInvalid = (this.state.password !== this.state.passwordRepeat) && passwordRepeatTouched && !!this.state.passwordRepeat;
        const passwordRepeatError = passwordRepeatInvalid ? 'Passwords must match' : '';
        this.setState({ passwordRepeatInvalid, passwordRepeatError });
      }
      return !passwordInvalid && !passwordRepeatInvalid && this.state.password && this.state.password === this.state.passwordRepeat;
    };

    this.verifyRecaptcha = () => {
      this.setState({ recaptchaVerified: true });
    };
  }
  checkToken() {
    const { token } = this.state;
    if (this.state.checkToken) {
      window.AvaCAS.verifyToken({ token })
        .then(({ data, headers, request }) => {
          this.setState({ userId: data.id, username: data.username, checkToken: false });
        }, ({ response }) => {
          this.setState({ invalidToken: true });
        });
    }
    else {
      this.setState({ invalidToken: true });
    }
  }
  componentDidMount() {
    this.checkToken();
    this.validate();
  }
  componentWillMount() {
    const query = queryString.parse(window.location.search);
    this.setState({ token: query.token, checkToken: !!query.token });
  }
  render() {
    const { classes } = this.props;
    const { checkToken, afterReset, invalidToken } = this.state;
    if (afterReset) {
      return ( <Redirect to="/forgotPasswordComplete" /> );
    }
    if (invalidToken) {
      return (
        <div>
          <form
            className={classes.form}>
            <div
              className={classes.header}>
              <IconButtonLink
                to="/"><IconArrowBack /></IconButtonLink>
              <h2>Reset your password</h2>
            </div>
            { this.props.invalidTokenText.split('\n').map((item, key) => <p className={classes.text} key={key}>{item}</p>) }
          </form>
        </div>
      );
    }
    if (checkToken) {
      return (
        <div>
          <form
            className={classes.form}>
            <div
              className={classes.header}>
              <IconButtonLink
                to="/"><IconArrowBack /></IconButtonLink>
              <h2>Reset your password</h2>
            </div>
          </form>
        </div>
      );
    }
    return (
      <div>
        <form
          className={classes.form}>
          <div
            className={classes.header}>
            <IconButtonLink
              to="/"><IconArrowBack /></IconButtonLink>
            <h2>Reset your password</h2>
          </div>
        <IcoTextField
          icon={IconVpnKey}
          required
          id="password"
          name="password"
          label="New password"
          type="password"
          value={this.state.password}
          margin="normal"
          helperText={this.state.passwordError}
          onBlur={this.handleBlur}
          onChange={this.updateState}
          error={this.state.password && this.state.passwordInvalid && this.state.passwordTouched}
          onKeyDown={(event) => event.key === 'Enter' ? this.resetPassword(event) : null }></IcoTextField>
        <IcoTextField
          icon={IconVpnKey}
          required
          id="passwordRepeat"
          name="passwordRepeat"
          label="Repeat new password"
          type="password"
          value={this.state.passwordRepeat}
          margin="normal"
          helperText={this.state.passwordRepeatError}
          onBlur={this.handleBlur}
          onChange={this.updateState}
          error={this.state.passwordRepeat && this.state.passwordRepeatInvalid && this.state.passwordRepeatTouched}
          onKeyDown={(event) => event.key === 'Enter' ? this.resetPassword(event) : null }></IcoTextField>
          <p
            className={classes.recaptcha}>
            <Recaptcha
              sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ''}
              render="explicit"
              verifyCallback={this.verifyRecaptcha}
            />
          </p>
          <p
            className={classes.notes}>{this.props.text}</p>
          { this.state.resetError &&
            ( <p
              data-error={true}
              className={classes.notes}>{this.props.errorText}</p> )
          }
          <div
            className={classes.actionButtons}>
            <span className="to-right">
              { this.state.inProgress && <CircularProgress className="in-progress" size={32} /> }
              <Button
                color="secondary"
                variant="contained"
                disabled={ !this.state.password || this.state.passwordRepeat !== this.state.password || this.state.passwordRepeatInvalid || this.state.passwordInvalid || this.state.inProgress || !this.state.recaptchaVerified }
                onClick={this.resetPassword}>Continue</Button>
            </span>
          </div>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(ResetPassword)



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/index.js